module.exports = __webpack_public_path__ + "static/media/BM_Billing.7cbcf18d.svg";